import { ukCatalog, type UkCatalog } from './catalogs/uk';

export const supportedLocales = ['uk-UA'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];
export type MessageKey = keyof UkCatalog['messages'];

const catalogs: Record<SupportedLocale, UkCatalog> = { 'uk-UA': ukCatalog };
let activeLocale: SupportedLocale = 'uk-UA';

export function locale(): SupportedLocale { return activeLocale; }

export function setLocale(next: SupportedLocale): void {
  activeLocale = next;
  if (typeof document !== 'undefined') document.documentElement.lang = catalogs[next].htmlLang;
  try { if (typeof localStorage !== 'undefined') localStorage.setItem('radio.locale', next); } catch { /* storage can be unavailable */ }
}

export function initializeLocale(): void {
  let remembered: string | null = null;
  try { if (typeof localStorage !== 'undefined') remembered = localStorage.getItem('radio.locale'); } catch { /* storage can be unavailable */ }
  setLocale(supportedLocales.includes(remembered as SupportedLocale) ? remembered as SupportedLocale : 'uk-UA');
}

export function t(key: MessageKey): string { return catalogs[activeLocale].messages[key]; }

export function itemTypeLabel(value: string): string { return lookup('itemTypes', value); }
export function transitionModeLabel(value: string): string { return lookup('transitionModes', value); }
export function stationModeLabel(value: string): string { return lookup('stationModes', value); }
export function engineStateLabel(value: string): string { return lookup('engineStates', value); }
export function connectionQualityLabel(value: string): string { return lookup('connectionQualities', value); }
export function healthStateLabel(value: string): string { return lookup('healthStates', value); }
export function incidentStateLabel(value: string): string { return lookup('incidentStates', value); }
export function severityLabel(value: string): string { return lookup('severities', value); }
export function slotTypeLabel(value: string): string { return lookup('slotTypes', value); }
export function sourceKindLabel(value: string): string { return lookup('sourceKinds', value); }
export function cartModeLabel(value: string): string { return lookup('cartModes', value); }

export function localizedProblem(problem: { code?: string; title?: string; detail?: string }): string {
  const code = problem.code ?? '';
  const translated = lookupOrNull('apiErrors', code);
  return translated ?? problem.detail ?? problem.title ?? 'Запит не виконано.';
}

function lookup(section: keyof Omit<UkCatalog, 'locale' | 'htmlLang' | 'messages'>, value: string): string {
  return lookupOrNull(section, value) ?? value.replaceAll('_', ' ');
}

function lookupOrNull(section: keyof Omit<UkCatalog, 'locale' | 'htmlLang' | 'messages'>, value: string): string | null {
  const values = catalogs[activeLocale][section] as Record<string, string>;
  return values[value] ?? null;
}
